import Navigation from './Navigation';

const DrawerContent = () => (
  <div className=''>
    <Navigation />
  </div>
);

export default DrawerContent;
